// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1WU8w","text":"button-module--text--AlOqM"};